import { FRIENDS_STATE, GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { getCurriculum } from '../../content/curriculum/curriculumStorage';

export const initialState = {
  alyxClickCount: 0,
  canLeaveBuddyWithoutPenalty: true, // wether or not hitting the back button while playing the current buddy will count as a strike towards failure.
  clubs: [],
  currentClueIndex: 0,
  currentFriendId: null,
  currentLevelNumber: 0,
  currentSelectedTraitId: '',
  friends: [],
  friendsState: {},
  friendsFailedCountSet: {}, // a list of friends who you have failed to sort into a club at least once.
  previouslySelectedCorrectTraits: [],
  previouslySelectedIncorrectTraits: [],
  shouldDisplayFriendCompleteModal: false,
};

const currentLevel = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.ADD_CORRECT_TRAIT:
      return {
        ...state,
        previouslySelectedCorrectTraits: [...state.previouslySelectedCorrectTraits, payload],
      };

    case REDUX_ACTIONS.ADD_INCORRECT_TRAIT:
      return {
        ...state,
        previouslySelectedIncorrectTraits: [...state.previouslySelectedIncorrectTraits, payload],
      };

    case REDUX_ACTIONS.CHANGE_PLAY_AREA:
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        canLeaveBuddyWithoutPenalty: true,
      };

    case REDUX_ACTIONS.TOGGLE_FRIEND_COMPLETE_MODAL:
      return {
        ...state,
        shouldDisplayFriendCompleteModal: !state.shouldDisplayFriendCompleteModal,
      };

    case REDUX_ACTIONS.GO_TO_NEXT_CLUE:
      return {
        ...state,
        currentClueIndex: state.currentClueIndex + 1,
        previouslySelectedIncorrectTraits: initialState.previouslySelectedIncorrectTraits,
      };

    case REDUX_ACTIONS.INCREMENT_ALYX_CLICK_COUNT:
      return {
        ...state,
        alyxClickCount: state.alyxClickCount + 1,
      };

    case REDUX_ACTIONS.LEAVE_BUDDY_EARLY: {
      const currentFailCount = state.friendsFailedCountSet[state.currentFriendId];
      const newFailCount = state.canLeaveBuddyWithoutPenalty ? currentFailCount : currentFailCount + 1;
      return {
        ...state,
        friendsFailedCountSet: {
          ...state.friendsFailedCountSet,
          [state.currentFriendId]: newFailCount,
        },
      };
    }

    case REDUX_ACTIONS.RESET_ALYX_CLICK_COUNT:
      return {
        ...state,
        alyxClickCount: 0,
      };

    case REDUX_ACTIONS.RESET_SELECTED_TRAIT:
      return {
        ...state,
        currentSelectedTraitId: initialState.currentSelectedTraitId,
      };

    case REDUX_ACTIONS.SELECT_TRAIT:
      return {
        ...state,
        currentSelectedTraitId: payload,
        canLeaveBuddyWithoutPenalty: false, // once you attempt to answer a question with a buddy, you're committed.
      };

    case REDUX_ACTIONS.SET_FRIEND_STATE:
      return {
        ...state,
        friendsState: { ...state.friendsState, [state.currentFriendId]: payload },
      };

    case REDUX_ACTIONS.RESET_CURRENT_FRIEND:
      return {
        ...state,
        currentFriendId: initialState.currentFriendId,
      };

    case REDUX_ACTIONS.RESET_CURRENT_LEVEL:
      return initialState;

    case REDUX_ACTIONS.SELECT_FRIEND:
      return {
        ...state,
        currentClueIndex: 0,
        currentFriendId: payload,
        previouslySelectedCorrectTraits: initialState.previouslySelectedCorrectTraits,
        previouslySelectedIncorrectTraits: initialState.previouslySelectedIncorrectTraits,
      };

    case REDUX_ACTIONS.FAIL_TO_PLACE_FRIEND: {
      const currentFailCount = state.friendsFailedCountSet[state.currentFriendId];
      return {
        ...state,
        friendsFailedCountSet: { ...state.friendsFailedCountSet, [state.currentFriendId]: currentFailCount + 1 },
      };
    }

    case REDUX_ACTIONS.SELECT_LEVEL: {
      const { clubs, friends } = getCurriculum().rounds[`round${payload}`];

      return {
        ...state,
        currentLevelNumber: payload,
        clubs,
        friends,
        friendsState: friends.reduce((acc, curr) => Object.assign(acc, { [curr]: FRIENDS_STATE.INCOMPLETE }), {}),
        friendsFailedCountSet: friends.reduce((acc, curr) => Object.assign(acc, { [curr]: 0 }), {}),
      };
    }

    case REDUX_ACTIONS.QUICK_ROUND: {
      return {
        ...state,
        friendsFailedCountSet: state.friends.reduce(
          (acc, friendId) => ({ ...acc, [friendId]: payload.pass ? 0 : 1 }),
          {},
        ),
      };
    }

    default:
      return state;
  }
};

export default currentLevel;
